import React from 'react';

import { Flex } from '@opendoor/bricks/core';
import { MarginProps } from '@opendoor/bricks/system/theme';

import {
  SubNavigationCard,
  SubNavigationCardProps,
} from 'sellDirect/components/offer/SubNavigationCard';
import { Section } from 'shared/components/Section';
import { getHubHomeDetailsRoute, getHubMarketTrendsRoute } from 'shared/helpers/routes';
import { useOfferContext } from 'sellDirect/OfferContext';

/**
 * Shows cards outlining different aspects that went into calculating an offer
 *
 * Each of the cards navigates to their respective sub-page:
 *   1. Comps
 *   2. Market trends
 *   3. Home details
 *
 * Accepts optional MarginProps to set the margin of the Section container
 */
export const WhatWentIntoYourOffer: React.FC<MarginProps> = (marginProps) => {
  const { shouldSeeAgentExperience, experimentationData } = useOfferContext();
  const title = experimentationData.isSdMacroCompsEnabled
    ? `What may impact ${shouldSeeAgentExperience ? 'your client’s' : 'your'} offer`
    : `What went into ${shouldSeeAgentExperience ? 'your client’s' : 'your'} offer`;

  const WHAT_WENT_INTO_YOUR_OFFER_BUTTONS: SubNavigationCardProps[] = [
    {
      type: 'internal-link',
      analyticsName: 'cake-market-trends',
      ['aria-label']: null,
      to: getHubMarketTrendsRoute(),
      children: 'Market trends',
    },
    {
      type: 'internal-link',
      analyticsName: 'cake-home-details',
      ['aria-label']: null,
      to: getHubHomeDetailsRoute(),
      children: 'Home details',
    },
  ];

  return (
    <Section title={title} {...marginProps}>
      <Flex as="ul" width="100%" flexDirection={['column', null, 'row']} gridGap={[5, null, 8]}>
        {WHAT_WENT_INTO_YOUR_OFFER_BUTTONS.map((subNavCardProps) => (
          <SubNavigationCard {...subNavCardProps} key={subNavCardProps.title} />
        ))}
      </Flex>
    </Section>
  );
};
